export default function XML_XSLT() {
  return (
    <div>
      <h1>XML_XSLT</h1>
      <p>This is the XML_XSLT component.</p>
    </div>
  );
}